import React from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, RefreshCw, Home, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ServerErrorProps {
  error?: Error | null;
  onRetry?: () => void;
}

const ServerError: React.FC<ServerErrorProps> = ({ error, onRetry }) => {
  const handleRetry = () => {
    if (onRetry) onRetry();
    else window.location.reload();
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center bg-background px-4 py-16">
      <div className="max-w-2xl w-full text-center">
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-secondary/10 mb-6">
          <AlertTriangle className="h-10 w-10 text-secondary" />
        </div>
        <p className="text-sm font-semibold tracking-widest uppercase text-secondary mb-4">
          Error 500
        </p>
        <h1
          className="text-5xl md:text-7xl font-extrabold mb-4 tracking-tight"
          style={{ color: "#000080" }}
        >
          Internal Server Error
        </h1>
        <p className="text-base md:text-lg text-muted-foreground mb-8 max-w-xl mx-auto">
          Something went wrong on our end while loading this page. Our team has
          been notified. You can try reloading, head back to the homepage, or
          reach out if the issue persists.
        </p>

        {error?.message && (
          <pre className="text-left text-xs bg-muted text-muted-foreground p-4 rounded-md mb-8 overflow-auto max-h-40 border">
            {error.message}
          </pre>
        )}

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            size="lg"
            onClick={handleRetry}
            style={{ backgroundColor: "#000080" }}
          >
            <RefreshCw className="mr-2 h-4 w-4" />
            Try Again
          </Button>
          <Button variant="outline" size="lg" asChild>
            <Link to="/">
              <Home className="mr-2 h-4 w-4" />
              Return Home
            </Link>
          </Button>
          <Button variant="ghost" size="lg" asChild>
            <Link to="/contact">
              <Mail className="mr-2 h-4 w-4" />
              Contact Support
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ServerError;
